var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"answerDetail"},[_c('div',{staticClass:"h5-html",domProps:{"innerHTML":_vm._s(_vm.html)},on:{"click":function($event){return _vm.previewImage($event)}}}),(_vm.isInWeixin)?_c('wx-inner-config',{ref:"wxInnerConfig"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }